import { z } from "zod";
/**
 * Percent insets for the seating planner room frame.
 *
 * Negative values extend the room beyond the reference canvas edge; positive
 * values inset it. Each axis only enforces a 1 % minimum room span so the
 * frame cannot collapse to zero.
 */
export const SeatingCanvasInsetSchema = z.object({
    top: z.number().min(-100).max(99),
    right: z.number().min(-100).max(99),
    bottom: z.number().min(-100).max(99),
    left: z.number().min(-100).max(99),
});
export const DEFAULT_SEATING_CANVAS_INSET = {
    top: 10,
    right: 8,
    bottom: 10,
    left: 8,
};
export const SEATING_CANVAS_INSET = {
    /** Most expanded: room may start one full canvas width/height outside origin. */
    min: -100,
    /** Most contracted per side (opposite side may still be negative → large room). */
    max: 99,
    /** Minimum room width/height as a % of the reference canvas. */
    minRoomPct: 1,
};
function clampInsetComponent(n) {
    return Math.max(SEATING_CANVAS_INSET.min, Math.min(SEATING_CANVAS_INSET.max, n));
}
/** Coerce stored inset to valid ranges; only caps maximum shrink (min room size). */
export function clampSeatingCanvasInset(i) {
    let top = clampInsetComponent(i.top);
    let left = clampInsetComponent(i.left);
    let right = clampInsetComponent(i.right);
    let bottom = clampInsetComponent(i.bottom);
    const maxInsetSum = 100 - SEATING_CANVAS_INSET.minRoomPct;
    if (left + right > maxInsetSum) {
        const s = maxInsetSum / (left + right);
        left *= s;
        right *= s;
    }
    if (top + bottom > maxInsetSum) {
        const s = maxInsetSum / (top + bottom);
        top *= s;
        bottom *= s;
    }
    return {
        top: Math.round(top * 100) / 100,
        left: Math.round(left * 100) / 100,
        right: Math.round(right * 100) / 100,
        bottom: Math.round(bottom * 100) / 100,
    };
}
